@let vm =
  {
    vehicle: vehicle$ | async,
    showFinanceCalculator: showFinanceCalculator$ | async,
    financingConfigForHeader: financingConfigForHeader$ | async
  };

<header class="cc-header-info">
  @defer {
    @if (vm.vehicle) {
      @if (isMobile$ | async) {
        <div class="cc-grid-container">
          <div class="cc-header-info__flex cc-header-info__outer-container" *ngrxLet="displayRates$ as displayRates">
            <div
              class="cc-header-info__container-left cc-header-info__flex cc-header-info__inner-container"
              [ngClass]="{
                'has-permanent-nba-and-wishlist': (isInIntegratedMode$ | async) && (isWishlistConfigured$ | async)
              }"
            >
              <ng-container *ngTemplateOutlet="vehicleName" />
              @if (displayRates) {
                <ng-container *ngTemplateOutlet="financialRateAndLabel" />
              } @else {
                @if (vm.vehicle?.priceInformation; as priceInformation) {
                  <div
                    class="cc-header-info__finance-price-container"
                    [ngClass]="{
                      'cc-header-info__finance-price-container--discounted': !!priceInformation?.discountedPrice
                    }"
                  >
                    <ng-container
                      *ngTemplateOutlet="financePrice; context: { vm: vm, priceInformation: priceInformation }"
                    />
                  </div>
                }
              }
              @if (isRegionPickerEnabledAndVehicleHasNoPrice$ | async) {
                <ccwb-button class="region-picker-button" (click)="openRegionPicker()" size="s" variant="tertiary">
                  <ng-container *ngTemplateOutlet="regionPickerNoPriceInfo" />
                </ccwb-button>
              }
              @if (isRegionPickerEnabledAndVehicleHasPrice$ | async) {
                <ccwb-button
                  (click)="openRegionPicker()"
                  aria-label="location picker"
                  icon-only
                  variant="tertiary"
                  size="m"
                >
                  <ng-container *ngTemplateOutlet="regionPickerLocationIcon" />
                </ccwb-button>
              }
              <cc-env-specific-title />
            </div>
            <div class="cc-header-info__flex">
              <cc-permanent-nba-button
                [ngClass]="{
                  'permanent-nba__with-save-btn': (isInIntegratedMode$ | async) && (isWishlistConfigured$ | async)
                }"
              />
              @if ((isInIntegratedMode$ | async) && (isWishlistConfigured$ | async)) {
                @let isMobile = isMobile$ | async;
                <cc-wishlist-save-button
                  [isFullFunctionalButton]="true"
                  [isMobile]="isMobile"
                  [size]="isMobile ? 'm' : 's'"
                  [saveColor]="isSummary ? 'secondary' : 'primary'"
                />
              }
            </div>
          </div>
        </div>
      } @else {
        <div class="cc-grid-container">
          <div class="cc-header-info__container">
            @if (hasPermanentNbas$ | async) {
              <ccwb-round-button
                class="cc-header-info__separator cc-header-info__space-right"
                id="subnav-toggle"
                (click)="toggleSubnavVisibility()"
                variant="tertiary"
                size="s"
              >
                @if (!subnavVisible) {
                  <ccwb-icon class="menu-button-icon" name="bds/more/24" />
                }
                @if (subnavVisible) {
                  <ccwb-icon class="menu-button-icon" name="bds/close/24" />
                }
              </ccwb-round-button>
            }
            <div class="cc-header-info--name cc-header-info__flex cc-header-info__space-right">
              <ng-container *ngTemplateOutlet="vehicleName" />
            </div>
            <div class="cc-header-info__finance">
              <ng-container *ngTemplateOutlet="regionPickerDesktopView" />
              @if (vm.vehicle?.priceInformation; as priceInformation) {
                <div
                  class="cc-header-info__finance-price-container cc-header-info__space-right"
                  [ngClass]="{
                    'footnote-spacing': priceInformation?.discountedPrice
                  }"
                >
                  <ng-container
                    *ngTemplateOutlet="financePrice; context: { vm: vm, priceInformation: priceInformation }"
                  />
                </div>
              }
              @if (vm.showFinanceCalculator) {
                <div class="cc-header-info__finance-price-container--nowrap cc-header-info__space-right">
                  <ng-container *ngTemplateOutlet="financialRateAndLabel" />
                </div>
              }
            </div>
            <cc-env-specific-title />
            <div class="cc-header-info__nba">
              @if ((isInIntegratedMode$ | async) && (isWishlistConfigured$ | async)) {
                <cc-wishlist-save-button
                  [isFullFunctionalButton]="true"
                  [size]="(isMobile$ | async) ? 'm' : 's'"
                  [saveColor]="isSummary ? 'secondary' : 'primary'"
                />
              }
            </div>
          </div>
        </div>
      }
      @if ((isMobile$ | async) === false && subnavVisible) {
        <div class="sub-navigation-container">
          <div class="cc-grid-container">
            <cc-permanent-nba
              [hasBeenOpened]="subnavHasBeenOpenedAtLeastOnce"
              [isHorizontal]="true"
              [useSubnavigation]="true"
              (nbaClicked)="hideSubnav()"
            />
          </div>
        </div>
      }
    }
  } @placeholder {
    <div class="skeleton-wrapper">
      @if (isMobile$ | async) {
        <div class="is-mobile-car-info-wrapper">
          <ccwb-skeleton class="mobile-car-name-bone" />
          <ccwb-skeleton class="mobile-label-bone" />
          <ccwb-skeleton class="mobile-value-bone" />
        </div>
        <ccwb-skeleton class="mobile-subnav-toggle-bone" />
      } @else {
        <ccwb-skeleton class="subnav-toggle-bone" />
        <ccwb-skeleton class="divisor-bone" />
        <ccwb-skeleton class="car-name-bone" />
        <div class="finance-price-wrapper">
          <ccwb-skeleton class="label-bone" />
          <ccwb-skeleton class="value-bone" />
        </div>
        <div class="discounted-price-wrapper">
          <ccwb-skeleton class="label-bone" />
          <ccwb-skeleton class="value-bone" />
        </div>
        <ccwb-skeleton class="save-button-bone" />
      }
    </div>
  }
</header>

<!--
  Vehicle name and price - Mobile View
  -->

<!-- Vehicle name and price - Desktop View -->

<!-- Vehicle name -->
<ng-template #vehicleName>
  @if (isMobile$ | async) {
    <div class="cc-header-info--name">
      <ccwb-text size="m" ellipsis>{{ vm.vehicle?.name }}</ccwb-text>
    </div>
  } @else {
    <ccwb-text size="l" strong ellipsis>{{ vm.vehicle?.name }}</ccwb-text>
  }
</ng-template>

<ng-template #financialRateAndLabel>
  <cc-finance-display
    [fcisRateInfo]="fcisRateInfo$ | async"
    [showFinancialCalculatorOpener]="(isMobile$ | async) === false"
    (openFinancialCalculator)="openFinancialCalculator()"
  />
</ng-template>

<ng-template #regionPickerDesktopView>
  @if (isRegionPickerEnabled$ | async) {
    <ccwb-button class="wb-margin-end-xs" (click)="openRegionPicker()" variant="tertiary" size="s">
      <ng-container *ngTemplateOutlet="regionPickerLocationIcon" />
      @if (hasVehicleAPrice$ | async) {
        @if (postalCode$ | async; as postalCode) {
          {{ postalCode }}
        }
      } @else {
        <!-- if vehicle request in progress it's not yet clear yet what to show, thus request needs to be finished -->
        @if ((isVehicleRequestTriggeredByPostalCodeChangeInProgress$ | async) === false && isRegionSelected$ | async) {
          <!-- "We are currently unable to show prices for this postal code. Please contact your nearest retailer." -->
          {{ 'regionPicker.error' | translate }}
        } @else {
          <!-- "Enter location to view drive away price" -->
          {{ 'regionPicker.cta' | translate }}
        }
      }
    </ccwb-button>
  }
</ng-template>

<ng-template #regionPickerLocationIcon>
  <ccwb-icon name="location" aria-hidden="true" />
</ng-template>

<!-- only shown (on desktop) if vehicle does _not_ have a price, therefore we show an error if vehicle does not have a price and region is not selected -->
<ng-template #regionPickerNoPriceInfo>
  <!-- if vehicle request in progress it's not yet clear yet what to show, thus request needs to be finished -->
  @if ((isVehicleRequestTriggeredByPostalCodeChangeInProgress$ | async) === false && isRegionSelected$ | async) {
    <!-- "We are currently unable to show prices for this postal code. Please contact your nearest retailer." -->
    {{ 'regionPicker.error' | translate }}
  } @else {
    <!-- "Enter location to view drive away price" -->
    {{ 'regionPicker.cta' | translate }}
  }
</ng-template>

<ng-template #financePrice let-vm="vm" let-priceInformation="priceInformation">
  @if ((usePLS$ | async) === false) {
    <ccwb-price size="s">
      <span slot="headline">{{ 'common.grosPrice' | translateAndObserve | async }}</span>
      <span class="cc-header-info__finance-price-headline" slot="price">
        <ng-container *ngTemplateOutlet="priceDisplay; context: { vm: vm, priceInformation: priceInformation }" />
      </span>
    </ccwb-price>
  } @else {
    <ng-container *ngTemplateOutlet="priceDisplay; context: { vm: vm, priceInformation: priceInformation }" />
  }
</ng-template>

<ng-template #priceDisplay let-vm="vm" let-priceInformation="priceInformation">
  @if (priceInformation.discountedPrice) {
    <ccwb-text
      class="cc-header-info__finance-price-container-value cc-header-info__finance-price-container-value-fix"
      tag="span"
      size="l"
      strong
    >
      <ccwb-icon class="cc-header-info__environmental-bonus-icon" name="consumption" aria-hidden="true" />
      @if (vm.vehicle) {
        <span>
          <cc-price-display-container [params]="priceDisplayParams" />
        </span>
      }
    </ccwb-text>
  } @else {
    @if (vm.vehicle && vm.vehicle?.priceInformation) {
      <cc-price-display-container [params]="priceDisplayParams" />
    }
  }
</ng-template>
